import { createBrowserRouter, RouterProvider } from "react-router-dom";
import RootLayout from "./RootLayout";
import ErrorPage from "./error-page";
import { GameLedger } from "./pages/ledger";
import React from "react";

import { AuthProvider } from "./contexts/AuthContext"
import Landing from "./pages/landing/Landing";
import { House } from "./pages/house";
import Members from "./pages/member/Members";
import { protectedLoader, redirectOnAuthenticatedLoader } from "./utilities/authUtils";
import { LoginPage } from "./pages/auth/LoginPage";
import { LogoutPage } from "./pages/auth/LogoutPage";
import { RegisterPage } from "./pages/signup/SignUpPage";
import AdminStats from './pages/admin/AdminStats';
import Favicon from './components/Favicon';
import GameDetails from './pages/admin/GameDetails';
import FeedbackPage from "./pages/feedback/FeedbackPage";
import HouseProvider from "./contexts/HouseContext";

const router = createBrowserRouter([
    {
        id: "root",
        path: "/",
        Component: RootLayout,
        ErrorBoundary: ErrorPage,
        children: [
            {
                index: true,
                element: <Landing/>,
            },
            {
                path: "sign-up",
                action: registerAction,
                loader: redirectOnAuthenticatedLoader,
                Component: RegisterPage,
            },
            {
                path: "login",
                loader: redirectOnAuthenticatedLoader,
                Component: LoginPage,
            },
            {
                path: "logout",
                Component: LogoutPage,
            },
            {
                id: "house",
                path: "games",
                element: <HouseProvider><House /></HouseProvider>,
                loader: protectedLoader()
            },
            {
                path: "members",
                element: <HouseProvider><Members/></HouseProvider>,
                loader: protectedLoader(),
                children: [
                    {
                        path: ':memberId',
                    }
                ]
            },
            {
                path: "games/:gameId",
                element: <HouseProvider><GameLedger/></HouseProvider>,
                loader: protectedLoader(),
            },
            {
                path: "/feedback",
                element: <HouseProvider><FeedbackPage/></HouseProvider>,
                loader: protectedLoader(),
            },
            {
                path: "/admin/stats",
                Component: AdminStats,
                loader: protectedLoader(),
            },
            {
                path: "/admin/stats/last-month",
                Component: GameDetails,
                loader: protectedLoader(),
            },
        ]
    },
]);

async function registerAction({ request }) {
    const { email, password, firstName, lastName, description, redirectTo } = Object.fromEntries(await request.formData())

    if (!email || !password || !description) {
        return {
            error: "You must provide username and password and description to register"
        }
    }

    try {
        const response = await fetch("/register", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                email,
                password,
                firstName,
                lastName,
                description,
            }),
        });

        if (response.status === 409) {
            return { error: `A user already exists with email: ${email}` };
        }
        if (!response.ok) {
            return { error: "Registration failed" };
        }
        return { success: true, redirectTo };
    } catch (err) {
        console.log("register failed...", err);
        return { error: "Registration failed" };
    }
}

export default function App() {
    return (
        <AuthProvider>
            <Favicon />
            <RouterProvider
                router={router}
                fallbackElement={<p>Initial Load...</p>}
            />
        </AuthProvider>
    );
}
